import defaultTheme from 'tailwindcss/defaultTheme';
import plugin from 'tailwindcss/plugin';
import { BORDER_RADIUS, BORDER_WIDTH, COLORS, SPACING, theme,
// @ts-expect-error No type declaration in design-tokens
 } from '@themenu/design-tokens-tailwind';
export default {
    content: ['./src/**/*.{ts,tsx}'],
    darkMode: ['variant', ['&:is(.dark *):not(.light *)', '&:is(.light .dark *)']],
    safelist: [{ pattern: /^m(\w?)-/ }, { pattern: /^p(\w?)-/ }],
    theme: {
        colors: Object.assign(Object.assign(Object.assign({}, COLORS), theme), { transparent: 'transparent' }),
        screens: {
            xs: '445px',
            sm: '512px',
            md: '768px',
            lg: '1280px',
            xl: '1920px',
        },
        borderRadius: Object.assign({ 0: defaultTheme.borderRadius.none, 4: '0.25rem', 8: '0.5rem', 12: '0.75rem', 16: '1rem', 20: '1.25rem', 24: '1.5rem', full: defaultTheme.borderRadius.full, DEFAULT: BORDER_RADIUS.xs }, BORDER_RADIUS),
        borderWidth: Object.assign({ DEFAULT: BORDER_WIDTH.thin }, BORDER_WIDTH),
        fontFamily: {
            sans: ['Graphik', 'sans-serif'],
            content: ['Graphik', 'sans-serif'],
            heading: ['Swile', 'sans-serif'],
        },
        fontSize: {
            11: '0.6875rem',
            12: '0.75rem',
            14: '0.875rem',
            16: '1rem',
            18: '1.125rem',
            20: '1.25rem',
            22: '1.375rem',
            24: '1.5rem',
            28: '1.75rem',
            32: '2rem',
            40: '2.5rem',
        },
        spacing: {
            inherit: 'inherit',
            0: '0',
            1: '0.0625rem',
            2: '0.125rem',
            4: '0.25rem',
            6: '0.375rem',
            8: '0.5rem',
            10: '0.625rem',
            12: '0.75rem',
            14: '0.875rem',
            16: '1rem',
            20: '1.25rem',
            24: '1.5rem',
            28: '1.75rem',
            32: '2rem',
            36: '2.25rem',
            40: '2.5rem',
            44: '2.75rem',
            48: '3rem',
            52: '3.25rem',
            56: '3.5rem',
            60: '3.75rem',
            64: '4rem',
            68: '4.25rem',
            72: '4.5rem',
            76: '4.75rem',
            80: '5rem',
            84: '5.25rem',
            88: '5.5rem',
            92: '5.75rem',
            96: '6rem',
            100: '6.25rem',
            120: '7.5rem',
        },
        dropShadow: {
            low: ['0px 4px 12px rgb(0 0 0 / 0.1)', '0px 4px 8px rgb(0 0 0 / 0.04)'],
            medium: ['0px 4px 24px rgb(0 0 0 / 0.1)', '0px 4px 16px rgb(0 0 0 / 0.04)'],
            high: ['0px 0px 48px rgb(0 0 0 / 0.1)', '0px 8px 24px rgb(0 0 0 / 0.04)'],
        },
        boxShadow: {
            low: '0px 0px 12px rgb(0 0 0 / 0.1), 0px 4px 8px rgb(0 0 0 / 0.04)',
            medium: '0px 4px 24px rgb(0 0 0 / 0.1), 0px 4px 16px rgb(0 0 0 / 0.04)',
            high: '0px 0px 48px rgb(0 0 0 / 0.1), 0px 8px 24px rgb(0 0 0 / 0.04)',
        },
        keyframes: {
            'caret-blink': { '0%,70%,100%': { opacity: '1' }, '20%,50%': { opacity: '0' } },
            'fade-in': { from: { opacity: '0' }, to: { opacity: '1' } },
            'fade-in-right': {
                from: { opacity: '0', transform: 'translateX(30px)' },
                to: { opacity: '1', transform: 'translateX(0px)' },
            },
            'fade-in-down': {
                from: { opacity: '0', transform: 'translateY(-30px)' },
                to: { opacity: '1', transform: 'translateY(0px)' },
            },
            'fade-in-left': {
                from: { opacity: '0', transform: 'translateX(-30px)' },
                to: { opacity: '1', transform: 'translateX(0px)' },
            },
            'fade-in-top': {
                from: { opacity: '0', transform: 'translateY(30px)' },
                to: { opacity: '1', transform: 'translateY(0px)' },
            },
            'fade-out': { from: { opacity: '1' }, to: { opacity: '0' } },
            'fade-out-right': {
                from: { opacity: '1', transform: 'translateX(0px)' },
                to: { opacity: '0', transform: 'translateX(30px)' },
            },
            'fade-out-down': {
                from: { opacity: '1', transform: 'translateY(0px)' },
                to: { opacity: '0', transform: 'translateY(30px)' },
            },
            'fade-out-left': {
                from: { opacity: '1', transform: 'translateX(0px)' },
                to: { opacity: '0', transform: 'translateX(-30px)' },
            },
            'fade-out-top': {
                from: { opacity: '1', transform: 'translateY(0px)' },
                to: { opacity: '0', transform: 'translateY(-30px)' },
            },
            'slide-in-right': { from: { transform: 'translateX(100%)' }, to: { transform: 'translateX(0px)' } },
            'slide-out-right': { from: { transform: 'translateX(0px)' }, to: { transform: 'translateX(100%)' } },
            'zoom-in': { from: { opacity: '0', transform: 'scale(1.05)' }, to: { opacity: '1', transform: 'scale(1)' } },
            'zoom-out': { from: { opacity: '1', transform: 'scale(1)' }, to: { opacity: '0', transform: 'scale(1.05)' } },
        },
        animation: {
            'caret-blink': 'caret-blink 1.25s ease-out infinite',
            'fade-in': 'fade-in 250ms linear both',
            'fade-in-right': 'fade-in-right 250ms linear both',
            'fade-in-down': 'fade-in-down 250ms linear both',
            'fade-in-left': 'fade-in-left 250ms linear both',
            'fade-in-top': 'fade-in-top 250ms linear both',
            'fade-out': 'fade-out 250ms linear both',
            'fade-out-right': 'fade-out-right 250ms linear both',
            'fade-out-down': 'fade-out-down 250ms linear both',
            'fade-out-left': 'fade-out-left 250ms linear both',
            'fade-out-top': 'fade-out-top 250ms linear both',
            'slide-in-right': 'slide-in-right 250ms linear both',
            'slide-out-right': 'slide-out-right 250ms linear both',
            'zoom-in': 'zoom-in 250ms linear both',
            'zoom-out': 'zoom-out 250ms linear both',
        },
        extend: {
            padding: SPACING,
            margin: SPACING,
            gap: SPACING,
            space: SPACING,
            translate: SPACING,
        },
    },
    plugins: [
        plugin(({ addVariant, addComponents, addUtilities, theme }) => {
            addVariant('progress-unfilled', '&::-webkit-progress-bar');
            addVariant('progress-filled', ['&::-webkit-progress-value', '&::-moz-progress-bar']);
            addVariant('svg-children', [
                '& svg path',
                '& svg circle',
                '& svg ellipse',
                '& svg line',
                '& svg polygon',
                '& svg polyline',
                '& svg rect',
            ]);
            addVariant('not-supports-dvh', '@supports not (height: 100dvh)');
            addComponents({
                '.fill-color-transparent': { '-webkit-text-fill-color': 'transparent', '-moz-text-fill-color': 'transparent' },
                '.arrow-on-right': {
                    // Dropdown arrow
                    '--color': theme('colors.content-default'),
                    backgroundImage: 'linear-gradient(45deg, transparent 50%, var(--color) 50%), linear-gradient(135deg, var(--color) 50%, transparent 50%)',
                    backgroundSize: '5px 5px',
                    backgroundPosition: 'calc(100% - 5px) center, 100% center',
                    backgroundRepeat: 'no-repeat',
                    '.dark &': { '--color': theme('colors.content-default-dark') },
                },
            });
            addUtilities({
                // Gradients
                '.bg-gradient-rainbow': { backgroundImage: theme('colors.gradient-rainbow-horizontal') },
                '.bg-gradient-pink': { backgroundImage: theme('colors.gradient-pink') },
                '.bg-gradient-green': { backgroundImage: theme('colors.gradient-green') },
                '.bg-gradient-blue': { backgroundImage: theme('colors.gradient-blue') },
                '.bg-gradient-purple': { backgroundImage: theme('colors.gradient-purple') },
            });
        }),
    ],
};
